<div class="position-relative">
    <button mat-stroked-button class="support-btn" [matMenuTriggerFor]="helpMenu"
        #createPlanmenuTrigger="matMenuTrigger" #supportBtnRef
        (mouseenter)="targetMenuTrigger = createPlanmenuTrigger; mouseEnter(createPlanmenuTrigger)"
        (mouseleave)="mouseLeave(createPlanmenuTrigger, supportBtnRef)">
        Support
        <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
    </button>
    <!-- Support POPUP -->
    <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
        <div (mouseenter)="mouseEnter(targetMenuTrigger)" (mouseleave)="mouseLeave(targetMenuTrigger, supportBtnRef)"
            class="popup-content px-3 py-2">
            <p class="fw-bold">Need Assistance?</p>
            <hr>
            <div class="d-flex align-items-center">
                <img src="assets/img/phone-call.png" alt="Phone" class="me-2">
                <a href="tel:+918422887258">+91 84228 87258</a>
            </div>
            <hr>
            <div class="d-flex align-items-center mt-2">
                <img src="assets/img/mail.png" alt="Email" class="me-2">
                <a href="mailto:contact@iited.com" class="text-decoration-underline">contact&#64;iited.com</a>
            </div>
        </div>
    </mat-menu>
</div>